export const SUBSCRIPTIONS_ROUTE = 'abonnement'
export const DETAILS_ROUTE = 'detaljer'
export const PERSONALIA_ROUTE = 'personalia'
export const SUMMARY_ROUTE = 'sammendrag'
export const RESOURCES_ROUTE = 'ressurser'
export const USERS_ROUTE = 'brukere'

export const relativeUrl = url => `/${url}`
